module.exports = __webpack_public_path__ + "img/92188.2fc375b9.svg";